import React, { useContext, useState } from "react";
import Grid from "@material-ui/core/Grid";
import * as Dati from "src/Dati";
import { Trad } from "src/components/";
import { _PasswordField } from "../../form/";
import { _ButtonAPI, _Dialog } from "../../components/";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

interface IPasswordChangeProps {
    Open: boolean;
    UserId: number;
    OnClose: () => void;
}

export const _PasswordChange: React.FC<IPasswordChangeProps> = ({ Open, UserId, OnClose }) => {
    const { ShowDialog } = useContext(AlertDialogContext);

    const [newPassword, setNewPassword] = useState("");
    const [confirmedPassword, setConfirmedPassword] = useState("");

    const onClickChangePassword = (data: Dati.CRisAPI) => {
        OnClose();

        if (data.Errore) {
            ShowDialog("ERRORE", Trad.Trad(data.ErrTesto), "error");
        } else {
            ShowDialog("Password change", Trad.Trad("Password has been changed"), "success");
        }
    };

    const OnError = (error: Error) => {
        OnClose();
        ShowDialog("ERRORE", Trad.Trad(error.message), "error");
    };

    const isFormValid = !!(newPassword && confirmedPassword && newPassword == confirmedPassword);

    return (
        <_Dialog
            Open={Open}
            Title={Trad.Trad("Password change")}
            Type="warning"
            OnClose={OnClose}
            Actions={
                <_ButtonAPI
                    Default
                    URL={`/api/Utenti/inar2/InAR2_ChangePassword/${UserId}`}
                    Metodo="PUT"
                    Testo={Trad.Trad("Cambia")}
                    ParamCorpo={{ Password: newPassword }}
                    OnClick={onClickChangePassword}
                    OnErrore={OnError}
                    Attivo={isFormValid}
                />
            }
        >
            <form noValidate>
                <Grid container justify="center" spacing={4}>
                    <Grid item xs={12} sm={8}>
                        <_PasswordField Value={newPassword} Label="New password" OnChange={e => setNewPassword(e.currentTarget.value)} />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <_PasswordField Value={confirmedPassword} Label="Confirm password" OnChange={e => setConfirmedPassword(e.currentTarget.value)} HideBar />
                    </Grid>
                </Grid>
            </form>
        </_Dialog>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/User/PasswordChange.tsx